module.exports = __webpack_public_path__ + "img/85-charles_dickens_quotes.b922d361.jpeg";